var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"the_layout"},[_c('div',{staticClass:"the_layout_wrap"},[_c('Header'),_c('div',{staticClass:"layout_bottom"},[_c('Aside'),_c('Main')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }